import React from "react";

import { styled } from "@mui/material";

import { useProgressBarContext } from "../../../context/ProgressBarContext";
import { BreakpointIcon } from "../components/BreakpointIcon";

export const BreakpointIcons = () => {
  const { state } = useProgressBarContext();

  return (
    <Container className={"ig-icons"}>
      {state.breakpoints.map((b, index) => {
        return <Icon key={index} breakpoint={b} />;
      })}
    </Container>
  );
};

const Container = styled("div")({
  display: "flex",
  marginBottom: 10,
});

const Icon = styled(BreakpointIcon)({
  flex: 1,
});
